import { motion } from 'framer-motion'
import { Clock, CreditCard, Database, Zap } from 'lucide-react'

const benefits = [
  {
    icon: Clock,
    title: 'Заявки без ожидания',
    description: 'Бот работает 24/7, задаёт уточняющие вопросы и автоматически передаёт готовые заявки в вашу CRM',
    gradient: 'from-blue-500 to-cyan-500'
  },
  {
    icon: CreditCard,
    title: 'Продажи и оплата в чате',
    description: 'Интеграция с ЮKassa и CloudPayments. Выдача доступа или оформление заявки сразу после оплаты',
    gradient: 'from-purple-500 to-pink-500'
  },
  {
    icon: Database,
    title: 'Интеграция с CRM',
    description: 'Подключаем Bitrix24, amoCRM, 1С. Передаём этапы, источники и формируем единую базу для отдела продаж',
    gradient: 'from-orange-500 to-red-500'
  },
  {
    icon: Zap,
    title: 'Меньше ручной работы',
    description: 'Автоматизируем FAQ, рассылки, опросы и напоминания. Ваша команда занимается только сложными задачами',
    gradient: 'from-green-500 to-teal-500'
  }
]

export default function BenefitsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Быстрый эффект от внедрения
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Telegram-бот закрывает рутинные задачи и освобождает ресурсы команды для стратегических целей
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8, transition: { duration: 0.3 } }}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all border border-gray-100"
            >
              {/* Icon with gradient background */}
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${benefit.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <benefit.icon className="w-8 h-8 text-white" strokeWidth={2} />
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>

              {/* Decorative element */}
              <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${benefit.gradient} opacity-0 group-hover:opacity-100 transition-opacity rounded-b-2xl`} />
            </motion.div>
          ))}
        </div>

        {/* Trust bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 pt-12 border-t border-gray-200"
        >
          <div className="flex flex-wrap items-center justify-center gap-8 text-gray-500">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm font-medium">Работаем по договору</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm font-medium">Работаем без НДС</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm font-medium">Bitrix24 • amoCRM • 1С</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm font-medium">ЮKassa • CloudPayments</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
